import React from "react";

function UserMobileCard({ user, roleName, onEdit, onDelete }) {
    return (
         <li className="reservation-card">
            <div className="card-header">     
                 <p>{user.name}</p>         
                <span className={`role-badge ${roleName.toLowerCase()}`}>
                    {roleName}
                </span>
            </div>
            
            <div className="card-content">
                <div className="card-body">
                   
                    <div className="row">                       
                        <p><strong>📞</strong> {user.phone}</p>
                    </div>
                    <div className="row">                       
                        <p><strong>📧</strong> {user.email}</p>
                    </div>
                </div>
                
                    <div>
                        <button className="serve-btn" onClick={onEdit}>
                            ✎ Edit
                        </button>
                        <button className="cancel-btn" onClick={onDelete}>
                            ✖ Delete
                        </button>
                    </div>
            </div>
        </li>
    );
}

export default UserMobileCard;